<p-paginator  [rows]="[rows]"
             [totalRecords]="[totalRecords]"
             pageLinkSize="3"
             (onPageChange)="onPageChange.emit($event)">
</p-paginator>
